export default __webpack_public_path__ + "static/media/image-ph-health-alarm-m@2x.f0564dad.png";